<template lang="pug">
    div(class=" w-full flex justify-center pl-5 pr-5 1024:pl-10 1024:pr-10" :class="getTextColor()")
        transition(name='fade' mode='out-in' appear)
            div(class="w-full 1280:w-1150")
                header.pt-10.flex.justify-between.items-center
                    div(:class="getLogo().width")
                        img.w-full(:src="getLogo().img")
                    
                    //- button.underline.text-background(@click="onLogout") выход
                
                section(class="flex flex-col justify-center 1024:grid 1024:grid-cols-2")
                    slot(name="content")
                    section(title="image" class="mt-20 1024:mt-0 w-full relative h-400 1024:h-700 flex flex-col items-center")
                        div(class="1024:absolute w-full 1024:w-500 cloud-animation")
                            img.w-full(:src="getImage().img")
                        div(class="w-full 1024:w-500 mt-auto")
                            img(:src="IMAGES.SHADOW")
                footer
                    slot(name="footer")
</template>

<script>
//Store
import { AuthorizationNameSpace, AuthorizationActionTypes } from '@/store/authorization/types';
import { RootActionTypes, RootGetterTypes, RootMutationTypes } from '@/store/types';

export default {
    name: "MainLayout",
    computed: {
        SETTINGS() {
            return this.$store.getters[`${RootGetterTypes.GetSettings}`]
        },
        IMAGES() {
            return {
                'SHADOW': require('@/static/imgs/design/box-shadow.svg'),
            }
        },
    },
    mounted() {
        this.getHost()
    },
    methods: {
        //Определяет группу (дфм, хитфм и т.д.) для выбора соотв. настроек дизайна
        getHost() {
            this.$store.dispatch(`${RootActionTypes.SetHost}`)
            this.getSettings()
        },
        getSettings() {
            this.$store.commit(`${RootMutationTypes.SetSettings}`)
            this.setFavicon(this.SETTINGS.logo)
        },
        setFavicon(href) {
            if (!href) {
                return
            }
            let link = document.querySelector("link[rel='icon']")
            if (!link) {
                link = document.createElement('link')
                link.setAttribute('rel', 'icon')
                document.head.appendChild(link)
            }
            link.setAttribute('type', 'image/svg+xml')
            link.setAttribute('href', href)
        },
        getLogo() {
            return { img: this.SETTINGS.logo , width: this.SETTINGS.logo_width }
        },
        getImage() {
            return { img: this.SETTINGS.main_image }
        },
        getTextColor() {
            return this.SETTINGS.text_color
        },
        async onLogout() {            
            await this.$store.dispatch(`${AuthorizationNameSpace}/${AuthorizationActionTypes.Logout}`)
                .then(() => {
                    this.$router.push('/')
                })
        },
    },
}
</script>